import { render, staticRenderFns } from "./sidebar-matches.vue?vue&type=template&id=aff8734a&"
import script from "./sidebar-matches.vue?vue&type=script&lang=js&"
export * from "./sidebar-matches.vue?vue&type=script&lang=js&"
import style0 from "./sidebar-matches.vue?vue&type=style&index=0&id=aff8734a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports